import { ChartColumn } from 'lucide-react';
import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import type { ModuleDefinition } from '../../app/modules';
import { useReportsAvailable } from './api';

/**
 * Звіти, панелі показників і аналітика (М15): конструктор звітів (джерело → поля → фільтри → групування →
 * агрегати → сортування → подання; таблиця, стовпчики, лінія, кругова; CSV), збережені звіти (особисті,
 * спільні, типові), словник показників (перевірка якості даних, запуск, значення за періодами, ручне значення
 * з доказом, «потрібні дані»), панелі за ролями з віджетами (типові й особисті), розсилки за розкладом і
 * доставлені знімки. Кожен звіт виконується з правами того, хто дивиться.
 */
const page = (load: () => Promise<{ default: ComponentType }>): Pick<RouteObject, 'lazy'> => ({
  lazy: async () => ({ Component: (await load()).default }),
});

const reportsModule: ModuleDefinition = {
  key: 'reports',
  label: 'Звіти й аналітика',
  icon: ChartColumn,
  basePath: '/reports',
  scope: 'users:read',
  useAccess: useReportsAvailable,
  order: 45,
  routes: [
    {
      ...page(() => import('./ReportsLayout')),
      children: [
        { index: true, lazy: async () => ({ Component: (await import('./ReportsLayout')).ReportsIndex }) },
        { path: 'dashboards', ...page(() => import('./dashboards/DashboardsPage')) },
        { path: 'builder', ...page(() => import('./pages/BuilderPage')) },
        { path: 'saved', ...page(() => import('./pages/SavedReportsPage')) },
        { path: 'saved/:reportId', ...page(() => import('./pages/SavedReportPage')) },
        { path: 'metrics', ...page(() => import('./metrics/MetricsPage')) },
        { path: 'metrics/:metricId', ...page(() => import('./metrics/MetricPage')) },
        { path: 'subscriptions', ...page(() => import('./subscriptions/SubscriptionsPage')) },
        { path: 'deliveries', ...page(() => import('./deliveries/DeliveriesPage')) },
        { path: 'deliveries/:deliveryId', ...page(() => import('./deliveries/DeliveryPage')) },
      ],
    },
  ],
};

export default reportsModule;
